<template>
  <van-popup
    v-model="show"
    class="discount-popup"
    position="bottom"
    :style="{ height: 'auto' }"
    @close="onClose"
  >
    <div class="discount-popup-wrapper">
      <!-- 插画 -->
      <div class="discount-icon"></div>
      <p class="title">{{ $t('genshinNew.new_user_toast_title') }}</p>
      <div class="login-wrapper">
        <button
          v-for="item in buttons"
          class="btn flex-col-center"
          :class="item.name"
          :key="item.name"
          @click="login(item.name)"
        >
          <img v-lazy="item.logo" :alt="`${item.name} logo`" />
          <span class="text">{{ item.title }}</span>
        </button>
      </div>
      <div class="dividing-line"></div>
      <p class="tips">{{ $t('genshinNew.new_user_toast_info') }}</p>
      <button class="btn pay" @click="gotoPay">
        <MoneyDisplay
          class="pay-money"
          :number="Number(channelPrice)"
          :allowShowKcoin="true"
          :isKwalletSelected="isKwalletSelected"
        />
      </button>
    </div>
    <!-- <LoginBtn ref="loginComp" display="none" @login="loginEmit" /> -->
  </van-popup>
</template>
<script>
  // 未登录优惠弹窗 - 原神
  // import LoginBtn from '@/components/LoginBtn'
  import MoneyDisplay from '@/components/MoneyDisplay'
  import { mapState, mapMutations } from 'vuex'

  export default {
    name: 'DiscountPopup',
    components: {
      // LoginBtn,
      MoneyDisplay,
    },
    props: ['value', 'isKwalletSelected', 'channelPrice'],
    data() {
      return {
        show: this.value,
      }
    },
    computed: {
      ...mapState(['userInfo']),
      buttons() {
        return [
          {
            name: 'google',
            title: this.$t('common.login_google'),
            logo: require(`@/assets/images/common/icon/google.png`),
          },
          {
            name: 'vk',
            title: 'VK',
            logo: require(`@/assets/images/common/icon/vk-c.png`),
          },
        ]
      },
    },
    watch: {
      value(val) {
        this.show = val
      },
      userInfo(val) {
        // 如果监听到已登录，则关闭弹窗
        if (val && val.kicoinId && val.kicoinToken) {
          this.$emit('input', false)
        }
      },
    },
    methods: {
      ...mapMutations(['detail/setTuneUpLogin']),
      onClose() {
        this.$emit('input', false)
      },
      login(type) {
        this['detail/setTuneUpLogin']({
          type,
        })
      },
      gotoPay() {
        // 去支付
        this.$emit('gotoPay')
      },
      // loginEmit(res) {
      //   this.$emit('login', res)
      // },
    },
  }
</script>
<style lang="scss" scoped src="./index.scss"></style>
